/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Global styles
import "./src/styles/fonts.css"
import "./src/styles/variables.css"
import "./src/styles/global.css"

// RB2B visitor identification. onRouteUpdate fires on initial load AND every
// client-side route change; RB2B requires a re-fire per pageview in an SPA, so
// we remove and re-append the loader each time rather than guard against it.
// See RB2B SPA install guide (support.rb2b.com article 10126115).
export const onRouteUpdate = () => {
  const key = "QOQRJHKDLM62"
  const existing = document.getElementById("rb2b-script")
  if (existing) existing.remove()
  const s = document.createElement("script")
  s.id = "rb2b-script"
  s.async = true
  s.src = `https://ddwl4m2hdecbv.cloudfront.net/b/${key}/${key}.js.gz`
  document.body.appendChild(s)
}
